import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmModal } from './ui';
import { useAppContext } from '../context/AppContext';
import { QUOTA_EXCEEDED_MESSAGE } from '../services/apiClient';
import { isIndividualUser } from '../utils/productAccess';

const INDIVIDUAL_INQUIRY_MESSAGE =
  '이용 가능한 토큰이 모두 소진되었습니다.\n추가적인 이용은 문의 부탁드립니다.';

function UpgradeModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { user } = useAppContext();
  const isIndividual = isIndividualUser(user);

  if (!isOpen) return null;

  if (isIndividual) {
    return (
      <ConfirmModal
        isOpen={isOpen}
        type="warning"
        title="무료 체험 종료 안내"
        message={INDIVIDUAL_INQUIRY_MESSAGE}
        confirmText="이용 문의"
        showCancel
        cancelText="취소"
        align="dialog"
        className="trial-ended-confirm-modal"
        onConfirm={() => {
          onClose?.();
          navigate('/inquiry');
        }}
        onCancel={onClose}
      />
    );
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      type="warning"
      title="토큰 부족"
      message={QUOTA_EXCEEDED_MESSAGE}
      confirmText="확인"
      onConfirm={onClose}
      onCancel={onClose}
    />
  );
}

export default UpgradeModal;
